export function returnToClientProfile(history: any, clientId: number) {
  setTimeout(() => {
    history(`/client-profile/${clientId}`);
  });
}
